"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiManager_1 = require("../ApiManager");
var ApiConfig_1 = require("../config/ApiConfig");
/**
 * 일본 메인
 */
var ApiHome = /** @class */ (function (_super) {
    __extends(ApiHome, _super);
    function ApiHome() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.V2_MAIN = '/api/v2/main';
        _this.fetchMain = function (token) {
            var data = {
                token: token,
            };
            return ApiConfig_1.Axios.Client({
                header: { token: token },
                method: 'post',
                url: _this.V2_MAIN,
                data: data,
            });
        };
        return _this;
    }
    ApiHome.getInstance = function (initValue) {
        if (!ApiHome.classInstance) {
            this.classInstance = new ApiHome(initValue);
        }
        return this.classInstance;
    };
    return ApiHome;
}(ApiManager_1.ApiManager));
exports.default = ApiHome;
